module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"like":"like","comments":"No comments | One comment | {count} comment"},"fr":{"like":"favoris","comments":"Aucun commentaire | Un commentaire | {count} commentaires"}}')
  delete Component.options._Ctor
}
